import socketIoSetup from "config/socketIoSetup";
import { all_company } from "constants/configLocalStorage";
import { checkTimeOutData } from "Helpers/helpFunction";
import useA from "hook/useA";
import useAnalysis from "hook/useAnalysis";
import useChart from "hook/useChart";
import useCompany from "hook/useCompany";
import useMarket from "hook/useMarket";
import useMomentum from "hook/useMomentum";
import useNews from "hook/useNews";
import useReport from "hook/useReport";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCompanyInfo, setCompanySame } from "store/actionReducers/CompanyStore";
import { setNews } from "store/actionReducers/NewsStore";

export default function CommonApi() {
  const { fetchAllCompany } = useCompany();
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore)
  const ChartStore = useSelector((state: any) => state?.ChartStore)
  const dispatch = useDispatch();
  const { fetchChart, fetchDataFeedInstruments, filterStock } = useChart();
  const { fetchOverviewMomentum, fetchCashflowStockAnalysis } = useMomentum()
  const { fetchOverview, getGrowthOverview } = useA();
  const { fetchReport } = useReport();
  const { fetchStockBacktest } = useAnalysis();
  const { fetchWorld, fetchVietnam, fetchStockTicker } = useMarket()
  socketIoSetup()

  useEffect(() => {
    const dataStore = localStorage.getItem(all_company)
    const checkTime = checkTimeOutData(dataStore);
    if (checkTime?.value) {
      fetchAllCompany();
    } else {
      dispatch(setCompanyInfo(checkTime?.data))
    }
  }, [])

  useEffect(() => {
    fetchOverviewMomentum(StocksAnalysisStore?.inputSearch)
    fetchCashflowStockAnalysis(StocksAnalysisStore?.inputSearch)
    fetchOverview(StocksAnalysisStore?.inputSearch)
    getGrowthOverview(StocksAnalysisStore?.inputSearch)
    fetchReport(StocksAnalysisStore?.inputSearch)
    fetchStockBacktest(StocksAnalysisStore?.inputSearch)
    fetchStockTicker({ stock: StocksAnalysisStore?.inputSearch, time: 'day' })
  }, [StocksAnalysisStore?.inputSearch])

  useEffect(() => {
    fetchDataFeedInstruments()
    fetchWorld({ assetType: 'overview' })
    fetchVietnam({ time: '6M' })
  }, [])


  useEffect(() => {
    filterStock()
  }, [StocksAnalysisStore?.inputSearch, ChartStore?.datafeedInstruments])


  useEffect(() => {
    const from = moment().add('month', '-3').unix();
    const to = moment().add('minutes', '-1').unix();
    fetchChart({
      resolution: 'D',
      symbol: StocksAnalysisStore?.inputSearch,
      from: from,
      to: to
    })
  }, [StocksAnalysisStore?.inputSearch])

  return <div></div>
}